module.exports = __webpack_public_path__ + "img/KK0040C-BL.df811d12.jpg";